import React from 'react';
import PropTypes from 'prop-types';
import AsModal from './index';

const AsModalWithContext = ({ Context, children }) => {
  return (
    <Context.Consumer>
      {(ctx) => {
        const providedChildren = (props) => (
          <Context.Provider value={ctx}>{React.cloneElement(React.Children.only(children), props)}</Context.Provider>
        );
        const ChildrenAsModal = AsModal(providedChildren);
        return <ChildrenAsModal />;
      }}
    </Context.Consumer>
  );
};

AsModalWithContext.propTypes = {
  Context: PropTypes.any.isRequired,
  children: PropTypes.node.isRequired,
};

export default AsModalWithContext;
